import React, { useEffect, useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import Distribution_Sucess from "./Distribution_Sucess";

const Distribution_Office_Extend_data = async (params) => {
  const response = await fetch(`${process.env.REACT_APP_URL}/api/tso`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-React-Route": window.location.href,
    },
    body: JSON.stringify(params),
  });
  if (!response.ok) {
    throw new Error("Failed to fetch data");
  }
  return response.json();
};

const formatDateToInput = (date) => {
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};


const Distribution_Office_Extend = ({
  month,
  year,
  trans_date,
  dist_code,
  office_id,
  fps_id,
}) => {
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [tabHeading, setTabHeading] = useState(null);
  const [renderContentt, setRenderContentt] = useState(null);
  const [dates, setDates] = useState({});
  const [selectedRows, setSelectedRows] = useState({});

  const todayDate = new Date();
  const maxSelectableDate = new Date();
  maxSelectableDate.setDate(todayDate.getDate() + 15);

  const minDateStr = formatDateToInput(todayDate);
  const maxDateStr = formatDateToInput(maxSelectableDate);

  useEffect(() => {
    const getData = async () => {
      try {
        const response_data = await Distribution_Office_Extend_data({
          dist_code,
          month,
          year,
          trans_date,
          office_id,
          fps_id,
        });
        setTabHeading(response_data.heading);
        setReportData(response_data.data || []);
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };
    getData();
  }, [dist_code, month, year, trans_date]);

  const getNameForCell = (item) => {
    if (item.fps_id && item.fps_name_en) return item.fps_id;
    if (item.office_name_en) return item.office_name_en;
    if (item.afso_name_en) return item.afso_name_en;
    if (item.dist_name) return item.dist_name;
    return "-";
  };

  const handleDateChange = (index, value) => {
    setDates((prev) => ({ ...prev, [index]: value }));
  };

  const handleCheckboxChange = (index) => {
    setSelectedRows((prev) => ({ ...prev, [index]: !prev[index] }));
  };

  const handleSelectAll = () => {
    if (
      Object.keys(selectedRows).length === reportData.length &&
      Object.values(selectedRows).every((v) => v)
    ) {
      setSelectedRows({});
    } else {
      const allSelected = {};
      reportData.forEach((_, index) => {
        allSelected[index] = true;
      });
      setSelectedRows(allSelected);
    }
  };
  const nameHeading = reportData?.length
    ? reportData[0].fps_id
      ? "FPS"
      : reportData[0].office_name_en || reportData[0].afso_name_en
        ? "Office"
        : "District"
    : "District";

  const isAllSelected =
    reportData.length > 0 &&
    Object.keys(selectedRows).length === reportData.length &&
    Object.values(selectedRows).every((v) => v);

  // REUSABLE FUNCTION TO CALL THE SAME API
  const callUpdateApi = async (payload) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_URL}/api/Tsoupdate`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            'X-React-Route': window.location.href

          },
          body: JSON.stringify(payload),
        }
      );
      const result = await response.text();

      if (!response.ok) {
        throw new Error(result || "Update failed");
      }

      return result; // success message
    } catch (err) {
      throw err;
    }
  };

  const handleIndividualSubmit = async (item, index) => {
    if (!selectedRows[index]) {
      alert("Please select the checkbox for this row");
      return;
    }

    const selectedDate = dates[index] || item.version_date;

    if (!selectedDate) {
      alert("Please select a valid 'Up To' date");
      return;
    }

    const payload = {
      distCode: [item.dist_code],
      officeCode: [item.office_code],
      fps_id: [item.fps_id],
      versionDate: [selectedDate],
    };

    //console.log("Individual Submit Payload =>", payload);
    try {
      const result = await callUpdateApi(payload);
      alert(result + "");

      // Show success preview
      setRenderContentt(
        <Distribution_Sucess
          officeNameEn={
            item.office_name_en ||
            item.fps_name_en ||
            item.afso_name_en ||
            item.dist_name ||
            "Unknown"
          }
          office_code={item.office_code}
          month={item.month}
          year={item.year}
          version_date={selectedDate}
          dist_code={item.dist_code}
          fps_id={item.fps_id}
        />
      );

      setSelectedRows((prev) => ({ ...prev, [index]: false }));
    } catch (err) {
      alert("Individual submit failed: " + (err.message || "Try again"));
      setRenderContentt(null);
    }
  };

  // FINAL SUBMIT - Saves all selected rows
  const handleFinalSubmit = async () => {
    const selectedIndexes = Object.keys(selectedRows).filter(
      (i) => selectedRows[i]
    );

    if (selectedIndexes.length === 0) {
      alert("Please select at least one row");
      return;
    }

    const payload = {
      distCode: [],
      officeCode: [],
      fps_id: [],
      versionDate: [],
    };

    for (const index of selectedIndexes) {
      const item = reportData[index];
      const selectedDate = dates[index] || item.version_date;

      if (!selectedDate) {
        alert(`Please select date for row ${parseInt(index) + 1}`);
        return;
      }

      payload.distCode.push(item.dist_code);
      payload.officeCode.push(item.office_code);
      payload.fps_id.push(item.fps_id);
      payload.versionDate.push(selectedDate);
    }
    try {
      const result = await callUpdateApi(payload);
      alert(result || "Menus Enabled Successfully");

      // Optional: clear selections after final submit
      setSelectedRows({});
      setRenderContentt(null);
    } catch (err) {
      alert("Final submit failed: " + (err.message || "Try again"));
    }
  };

  if (loading)
    return (
      <Box display="flex" justifyContent="center" marginTop="50px">
        <CircularProgress />
      </Box>
    );
  <br></br>

  if (error) return <div align="center" className="mainhead" >Internal Error</div>;
  if (!reportData.length) return <div align="center" className="mainhead">No data found</div>;

  return (
    <>
      <br></br>
      <table align="center" width="70%" border={1} cellPadding="8">
        <thead>
          <tr className="tableheader">
            <th colSpan={7}>{tabHeading}</th>
          </tr>
          <tr className="tableheader">
            <td><strong>Sl No</strong></td>
            <td align="center">
              <input
                type="checkbox"
                checked={isAllSelected}
                onChange={handleSelectAll}
              />All
            </td>
            <td><strong>{nameHeading}</strong></td>
            <td><strong>Month</strong></td>
            <td><strong>Year</strong></td>
            <td><strong>Up To Date</strong></td>
            <td><strong>Action</strong></td>
          </tr>
        </thead>
        <tbody>
          {reportData.map((item, index) => (
            <tr key={item.office_code || item.fps_id || index}>
              <td align="center">{index + 1}</td>
              <td align="center">
                <input
                  type="checkbox"
                  checked={!!selectedRows[index]}
                  onChange={() => handleCheckboxChange(index)}
                />
              </td>
              <td>{getNameForCell(item)}</td>
              <td align="right">{item.month}</td>
              <td align="right">{item.year}</td>
              <td align="center">
                <input
                  type="date"
                  value={dates[index] || item.version_date || ""}
                  min={minDateStr}
                  max={maxDateStr}
                  onChange={(e) => handleDateChange(index, e.target.value)}
                  style={{ width: "150px" }}
                />
              </td>
              <td align="center">
                <button onClick={() => handleIndividualSubmit(item, index)} className="button button2" >
                  Submit
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div align="center" style={{ marginTop: "30px" }}>
        <button
          onClick={handleFinalSubmit}
          style={{
            padding: "10px 20px",
            fontSize: "18px",
            backgroundColor: "#d32f2f",
            color: "white",
            border: "none",
            borderRadius: "10px",
            cursor: "pointer",
          }}
        >
          Submit
        </button>
      </div>
      <div style={{ marginTop: "40px", textAlign: "center" }}>
        {renderContentt}
      </div>
    </>
  );
};

export default Distribution_Office_Extend;